import React, { useState, useEffect } from "react";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import { fetchProfile } from "../../../Services/ApiTestService/aadharTestService";
import { verifyMobileToBankBasic } from "../../../Services/ApiTestService/apiTestService";
import { InputWithLabel, Button } from "../../../Components/Tags/Tags";
import Loader from "../../../Loader";
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { useService } from "../../../context/ServiceContext";
import { isNumeric } from "validator";
import { AlertTriangle } from "lucide-react";

function MobileToBankBasic() {
  const [isLoading, setIsLoading] = useState(false);
  const [bankData, setBankData] = useState({});
  const [errors, setErrors] = useState({});
  const [profileData, setProfileData] = useState({});
  const [mobNumber, setMobNumber] = useState("");
  const [consent,setConsent] = useState(false);
  const { serviceName } = useService();
  const [inputError, setInputError] = useState(null);

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        setIsLoading(true);
        const response = await fetchProfile();
        setProfileData(response.data);
      } catch (error) {
        console.error("Error fetching profile data:", error);
        showErrorToast("Failed to fetch profile data.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfileData();
  }, []);

  const isNumber = (value) => {
    if (!value) return false;

    return isNumeric(value, { no_symbols: true });
  };

  const handleSubmit = async () => {
    const validateMobile = isNumber(mobNumber);

    if (!mobNumber) {
      return setInputError("⚠️ mobile field is required");
    } else if (!validateMobile) {
      return setInputError("⚠️ Please enter numbers in mobile field");
    }

    setInputError(null);
    try {
      setIsLoading(true);

      const response = await verifyMobileToBankBasic({
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        mobileNumber: mobNumber,
      });

      const statusCode = response?.status?.code;
      const statusMessage = response?.status?.message || response?.message;

      if (statusCode === 200) {
        const bankDetails = response?.data;

        if (bankDetails && typeof bankDetails === "object") {
          setBankData(bankDetails);
          showSuccessToast(
            statusMessage || "Mobile To Bank Verified successfully.",
          );
          setErrors({});
        } else {
          showErrorToast(
            "Bank details are missing or in an unexpected format.",
          );
        }
      } else {
        // In all other error cases, show the message
        const errorMessage =
          response?.message ||
          response?.data?.message ||
          statusMessage ||
          `Something went wrong. (code: ${statusCode})`;
        showErrorToast(errorMessage);
      }
    } catch (error) {
      console.error("Verify Mobile Bank Error:", error);
      showErrorToast("Failed to verify mobile details. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Seo />
      {isLoading && <Loader />}
      <Header heading={serviceName} />

      <div className="max-w-4xl mx-auto p-4">
        {/* Back button */}
        <div className="flex justify-end mb-4">
          <Link
            to="/TestMaster"
            className="flex items-center gap-2 text-sm text-white bg-green-600 hover:bg-green-700 px-3 py-2 rounded-md transition"
          >
            <IoArrowBackCircleOutline size={20} />
            Go Back
          </Link>
        </div>

        <div className="flex justify-center items-center gap-2 flex-wrap placeholder:mb-4">
          <label htmlFor="mobile" className="font-bold text-xl">
            Mobile <span className="font-bold text-xl text-red-700">*</span>
          </label>

          <input
            type="text"
            label="Mobile Number"
            placeholder="Enter mobile number"
            maxLength="10"
            className="w-fit rounded-md border border-gray-300 px-3 py-2 focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
            name="mobile_number"
            id="mobile_number"
            required
            value={mobNumber}
            onChange={(e) => setMobNumber(e.target.value)}
            error={errors.mobNumber}
          />


             <div className="flex items-center mt-2 ms-2">
  <input
    type="checkbox"
    id="consent"
    checked={consent}
    onChange={(e) => setConsent(e.target.checked)}
    className="mr-2 cursor-pointer size-6"
  />
  <label htmlFor="consent" className="text-sm text-gray-700">
    I informed the customer that the linked account number was being retrieved using their mobile number and that they would receive the penny drop in their bank account
  </label>
</div>

<div>
  <Button
    type="button"
    className={`text-center text-white shadow-lg font-semibold rounded-md px-2 py-1 mt-5 text-md border-4 ms-2
      ${
        consent
          ? 'bg-blue-900 bg-gradient-to-r from-blue-400 via-blue-600 to-blue-900 hover:from-blue-900 hover:to-blue-400 cursor-pointer'
          : 'bg-gray-400 cursor-not-allowed'
      }`}
    id="verifyMob"
    name="verifyMob"
    text="Verify"
    onClick={handleSubmit}
    disabled={!consent}
  />
</div>



        </div>

        {inputError && (
          <div className="flex justify-center pt-6 w-full text-red-700 text-2xl">
            {inputError}
          </div>
        )}
      </div>

      <div className="flex justify-center pt-6">
        <div className="bg-gradient-to-br from-purple-100 to-blue-100 text-black border p-5 mt-12 rounded-md flex flex-col items-start gap-2">
          <h3 className="font-bold text-lg mb-2 flex items-center gap-2">
            <AlertTriangle />
            Important Instructions <span className="text-red-600">*</span>
          </h3>

          <p className="text-sm leading-relaxed flex items-start justify-start gap-3">
            <span>●</span>
            Please enter valid Mobile number.
          </p>
          <p className="text-sm leading-relaxed flex items-start justify-start gap-3">
            <span>●</span>
            After successful verification, the system will return the JSON and
            table in response.
          </p>
          <p className="text-sm leading-relaxed flex items-start justify-start gap-3">
            <span>●</span>
            You may review and copy the response for your reference or further
            use.
          </p>
        </div>
      </div>

      {bankData && Object.keys(bankData).length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-4 my-4">
          {/* First Half - JSON Response */}
          <div className="bg-white border border-yellow-300 rounded-md shadow-lg p-4 overflow-auto max-h-96">
            <h2 className="text-lg font-semibold text-yellow-800 mb-3">
              Raw Response (JSON)
            </h2>
            <pre className="text-sm bg-gray-100 p-2 rounded-md">
              {JSON.stringify(bankData, null, 2)}
            </pre>
          </div>

          {/* Second Half - Bank Details */}
          <div className="bg-white border border-green-300 rounded-md shadow-lg p-4">
            <h2 className="text-lg font-semibold text-green-800 mb-3">
              Vpa Details
            </h2>
            <p>
              <strong>Vpa:</strong> {bankData.vpa}
            </p>
            <p>
              <strong>Account hholder name:</strong>{" "}
              {bankData.account_holder_name}
            </p>
            <p>
              <strong>Name match:</strong> {bankData.name_match}
            </p>
            <p>
              <strong>Name match score:</strong> {bankData.name_match_score}
            </p>

            <h2 className="text-lg font-semibold text-green-800 mb-3">
              Vpa Details
            </h2>

            <p>
              <strong>Account number:</strong> {bankData.account_number}
            </p>

            <p>
              <strong>IFSC Code:</strong> {bankData.account_ifsc}
            </p>
            <p>
              <strong>Client ID:</strong> {bankData.client_id}
            </p>

            <p>
              <strong>Account Deposited:</strong> {bankData.amount_deposited}
            </p>
          </div>
        </div>
      )}
    </>
  );
}

export default MobileToBankBasic;
